import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { HttpClient } from '@angular/common/http';
import { SessionService } from '../../authentication/session.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { whiteLabelTarget } from 'src/app/utils/whiteLabel';

@Component({
  selector: 'app-setpassword',
  templateUrl: './setpassword.component.html',
  styleUrls: [
    '../organic/signup/signup.component.css',
    '../login/login.component.css',
    '../organic/login/login.component.css',
  ],
})
export class SetpasswordComponent {
  // password: string = '';
  // confirmPassword: string = '';
  token: string;
  userID: string;

  public resetInformation: string =
    'Choose a strong password that you can easily remember, and make sure it helps keep your account secure';
  public resetInformationError: string = '';
  public warningMatch: string = 'Your password does not match!';
  public resetStatus: string = 'SUBMIT';
  public resetLoading: boolean = false;
  public finishedSend: boolean = false;
  public passwordValidation: boolean = false;
  public passwordValidationWarning: number;

  constructor(
    private authService: SessionService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private titleService: Title,
    private localStorageService: LocalStorageService,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.userID = params['userId'];
    });
  }

  form = this.fb.group({
    password: ['', Validators.required],
    confirmPassword: ['', Validators.required],
  });

  whiteLabelTarget = whiteLabelTarget;
  ngOnInit() {
    if (this.whiteLabelTarget) {
      this.titleService.setTitle(
        'Set Password - ' + this.whiteLabelTarget.description,
      );
    } else {
      this.titleService.setTitle('Set Password - Behamics');
    }
  }

  setPassword() {
    if (!this.form.valid) return;

    let password = this.form?.value?.password || '';
    let confirmPassword = this.form?.value?.confirmPassword || '';

    if (password == confirmPassword) {
      this.resetStatus = 'REQUESTING...';
      this.resetLoading = true;
      this.resetInformation = '';
      this.resetInformationError = '';
      this.authService
        .resetPassword(password, this.token, this.userID)
        .subscribe({
          next: (data: any) => {
            if (data['status'] == 3) {
              this.resetStatus = 'LOGGING IN...';

              // Login user if password reset is successful
              this.authService.login(data);
              this.authService.navigate(data);
            } else {
              this.resetStatus = 'SENT';
              this.resetLoading = false;
              this.finishedSend = true;
            }
          },
          error: (error: any) => {
            this.passwordValidationWarning = 2;
            this.resetInformationError = error.error.message;
            this.resetStatus = 'SUBMIT';
            this.resetLoading = false;
            console.log(error);
          },
        });
    } else {
      this.passwordValidationWarning = 1;
      this.warningMatch = 'Your password does not match!';
      this.passwordValidation = false;
    }
  }

  showPassword: boolean = false;
  toogleShowPassword() {
    this.showPassword = !this.showPassword;
  }
}
